import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { runtime } from '~/app/environment'

/**
 * Application name
 */
const appName = runtime.app.appName
document.title = `${appName ? appName : 'Tria'}` // set initial title

type AppTitleProps = {
  t?: string | string[]
  children?: React.ReactNode
}

/**
 * Sets document title
 */
AppTitle.displayName = 'AppTitle'
export function AppTitle({
  t: titleKey,
  children: titleText,
}: AppTitleProps): JSX.Element | null {
  const { t } = useTranslation()

  let title = ''
  if (Array.isArray(titleKey)) {
    title = titleKey.map((key) => t(key)).join(' - ')
  } else if (typeof titleKey === 'string') {
    title = t(titleKey)
  } else if (typeof titleText === 'string') {
    title = titleText
  }

  title = `${title} - ${appName ? appName : 'Tria'}`

  return <title>{title}</title>
}
